export default "__VITE_ASSET__sOgFTj_a__"